import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthCard from '../components/AuthCard';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  function handleSubmit(e) {
    e.preventDefault();
    if (email.trim()) {
      navigate('/forgot-sent', { state: { email } });
    }
  }

  return (
    <AuthCard backTo="/">
      <div className="page-header">
        <div className="page-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <h1 className="page-title">Glemt adgangskode?</h1>
        <p className="page-desc">Ingen stress — skriv din email, så sender vi dig et link til at nulstille den.</p>
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            placeholder="din@email.dk"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="login-btn">Send nulstillingslink</button>
      </form>

      <p className="login-footer">
        Huskede du den?{' '}
        <button className="link-btn" onClick={() => navigate('/')}>Log ind</button>
      </p>
    </AuthCard>
  );
}
